import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { formatDisplayDate } from "../../utils/formatDisplayDate";
import API from "../../utils/API";
import formatLink from "../../utils/formatLink";
import { saveOrg } from "../../redux/actions";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';

// Dashboard page components (kept exactly as you had)
import ManageWishlistPopup from "./manageWishlistPopup/ManageWishlistPopup";
import ManageMarketPlacePopup from "./manageMarketPlacePopup/ManageMarketPlacePopup";
import QuickSharePopup from "./quickSharePopup/QuickSharePopup";
import WhatsNewPopup from "./whatsNewPopup/WhatsNewPopup";
import DashboardSetting from "./dashboardSetting/DashboardSetting";
import GoToDaskboardPopup from "./goToDaskboardPopup/GoToDaskboardPopup";
import NonprofitApiIntegration from "../../components/NonprofitApiIntegration/NonprofitApiIntegration";
import MobileTopBar from "../../components/common/MobileTopBar";
import userIcon from "../../images/3.png";
import flagIcon from "../../images/18.png";
import { FaDownload, FaHome, FaTh, FaUser } from "react-icons/fa";

// Image imports

import "./MobileDashboard.css";
import { IoMdSettings } from "react-icons/io";

const MobileDashboard: React.FC = (props: any) => {
  const reduxOrg = useSelector((state: any) => state.org);

  // Modals (kept)
  const [wishList, setWishList] = useState(false);
  const [marketPlace, setMarketPlace] = useState(false);
  const [shareLink, setShareLink] = useState(false);
  const [whatsNew, setWhatsNew] = useState(false);
  const [goToDaskboardPopup, setGoToDaskboardPopup] = useState(false);
  const [dashboardSetting, setDashboardSetting] = useState(false);
  const [apiIntegration, setApiIntegration] = useState(false);
  const [socialShareHub, setSocialShareHub] = useState(false);
  const [showSharingModal, setShowSharingModal] = useState(false);
  const [selectedSharingItem, setSelectedSharingItem] = useState<string | null>(null);
  const [selectedCampaign, setSelectedselectedCampaign] = useState<any>(null);
  const [manageWishlistModal, setManageWishlistModal] = useState(false);
  const [manageStoreModal, setManageStoreModal] = useState(false);
  const [desktopOnlyModal, setDesktopOnlyModal] = useState(false);
  const [storeSubmitMessage, setStoreSubmitMessage] = useState<string>('');
  const [storeSubmitError, setStoreSubmitError] = useState<boolean>(false);
  const [showStoreSubmitModal, setShowStoreSubmitModal] = useState(false);
  const [wishlistSubmitMessage, setWishlistSubmitMessage] = useState<string>('');
  const [wishlistSubmitError, setWishlistSubmitError] = useState<boolean>(false);
  const [showWishlistSubmitModal, setShowWishlistSubmitModal] = useState(false);

  // Banner scroll state
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const bannerScrollRef = React.useRef<HTMLDivElement>(null);

  // Touch/Swipe handlers for banner scrolling
  const [touchStart, setTouchStart] = useState<number>(0);
  const [touchEnd, setTouchEnd] = useState<number>(0);

  // Manage Wishlist state
  const [wishlistInput, setWishlistInput] = useState({ _id: reduxOrg._id, wishlist: '' });
  const [wishlistSubmitting, setWishlistSubmitting] = useState(false);

  // Enhanced Donations Table state
  const [donations, setDonations] = useState<any[]>([]);
  const [sortField, setSortField] = useState<'date' | 'amount' | 'name'>('date');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const [loadingDonations, setLoadingDonations] = useState(false);

  // Campaigns state for fundraiser items
  const [campaigns, setCampaigns] = useState<any[]>([]);

  // Overview data state
  const [overviewData, setOverviewData] = useState<any>({ yearDonations: 0, supporters: 0, allDonations: 0 });
  const [loadingOverview, setLoadingOverview] = useState(false);

  // Manage Store state
  const [storeInput, setStoreInput] = useState({ _id: reduxOrg._id, marketplace: '' });
  const [storeSubmitting, setStoreSubmitting] = useState(false);

  // detect viewer timezone
  const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

  const dispatch = useDispatch();
  const history = useHistory();

  const handleStoreChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setStoreInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleStoreSubmit = async (event: any) => {
    event.preventDefault();
    if (storeSubmitting) return;
    setStoreSubmitting(true);

    const payload = { ...storeInput, marketplace: formatLink(storeInput.marketplace) };
    try {
      const response: any = await API.saveMarketplace(payload);
      if (response?.status === 200) {
        const newReduxOrg = { ...reduxOrg };
        newReduxOrg.actionItems.marketplace = payload.marketplace;
        dispatch(saveOrg(newReduxOrg));
        setStoreSubmitMessage('Store link saved successfully!');
        setStoreSubmitError(false);
        setShowStoreSubmitModal(true);
      } else {
        setStoreSubmitMessage('Failed to save store link. Please try again.');
        setStoreSubmitError(true);
        setShowStoreSubmitModal(true);
      }
    } catch (err) {
      console.log(err);
      setStoreSubmitMessage('An error occurred while saving the store link.');
      setStoreSubmitError(true);
      setShowStoreSubmitModal(true);
    } finally {
      setStoreSubmitting(false);
    }
  };

  const handleWishlistChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setWishlistInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleWishlistSubmit = async (event: any) => {
    event.preventDefault();
    if (wishlistSubmitting) return;
    setWishlistSubmitting(true);

    const payload = { ...wishlistInput, wishlist: formatLink(wishlistInput.wishlist) };
    try {
      const response: any = await API.saveWishlist(payload);
      if (response?.status === 200) {
        const newReduxOrg = { ...reduxOrg };
        newReduxOrg.actionItems.wishlist = payload.wishlist;
        dispatch(saveOrg(newReduxOrg));
        setWishlistSubmitMessage('Wishlist link saved successfully!');
        setWishlistSubmitError(false);
        setShowWishlistSubmitModal(true);
      } else {
        setWishlistSubmitMessage('Failed to save wishlist link. Please try again.');
        setWishlistSubmitError(true);
        setShowWishlistSubmitModal(true);
      }
    } catch (err) {
      console.log(err);
      setWishlistSubmitMessage('An error occurred while saving the wishlist link.');
      setWishlistSubmitError(true);
      setShowWishlistSubmitModal(true);
    } finally {
      setWishlistSubmitting(false);
    }
  };

  // Data fetching functions
  useEffect(() => {
    console.log('🔄 useEffect triggered, reduxOrg:', reduxOrg);
    if (reduxOrg._id) {
      console.log('✅ Organization ID found:', reduxOrg._id);
      fetchDonations();
      fetchOverviewData();
      fetchCampaigns();
    } else {
      console.log('❌ No organization ID available');
    }
  }, [reduxOrg._id]);

  const fetchOverviewData = async () => {
    if (!reduxOrg._id) return;

    setLoadingOverview(true);
    try {
      const response = await API.getNpOverview(reduxOrg._id);
      setOverviewData(response.data);
    } catch (error) {
      console.error('Error fetching overview data:', error);
      setOverviewData({ yearDonations: 0, supporters: 0, allDonations: 0 });
    } finally {
      setLoadingOverview(false);
    }
  };

  const fetchDonations = async () => {
    if (!reduxOrg._id) return;

    setLoadingDonations(true);
    try {
      // include viewer tz so server can compute day boundaries in user's timezone if desired
      const tzQuery = `tz=${encodeURIComponent(userTz)}`;
      const response = await API.getAllDonationsForNp(reduxOrg._id, tzQuery);
      setDonations(response.data || []);
    } catch (error) {
      console.error('Error fetching donations:', error);
      setDonations([]);
    } finally {
      setLoadingDonations(false);
    }
  };

  const fetchCampaigns = async () => {
    if (!reduxOrg._id) {
      console.log('No organization ID available for campaigns');
      return;
    }

    try {
      console.log('🔄 Fetching campaigns for org:', reduxOrg._id);
      const response = await API.getNpCampaigns(reduxOrg._id);
      console.log('📋 Campaigns API response:', response);

      if (response?.data) {
        console.log('📊 Campaigns data received:', response.data);
        const sortedCampaigns = response.data.sort((a: any, b: any) => b.createdAt - a.createdAt);
        console.log('📈 Sorted campaigns:', sortedCampaigns);
        setCampaigns(sortedCampaigns);
      } else {
        console.log('❌ No campaigns data in response');
        setCampaigns([]);
      }
    } catch (error) {
      console.error('❌ Error fetching campaigns:', error);
      setCampaigns([]);
    }
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const formatDate = (dateString: string) => formatDisplayDate(dateString);

  // const getStatusColor = (status: string) => {
  //   switch (status) {
  //     case 'Completed':
  //     case 'active':
  //       return 'success';
  //     case 'created':
  //       return 'warning';
  //     case 'Failed':
  //       return 'danger';
  //     default:
  //       return 'secondary';
  //   }
  // };

  const downloadCSV = (content: string, filename: string) => {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const convertToCSV = (data: any[]) => {
    if (data.length === 0) return '';
    const headers = ['Date', 'Amount', 'Email', 'Type', 'Status'];
    const csvRows = [headers.join(',')];

    data.forEach(donation => {
      const row = [
        donation.createdAt || donation.date || '',
        donation.amount || '0',
        donation.email || 'Anonymous',
        donation.type || 'One time',
        donation.status || 'Completed'
      ];
      csvRows.push(row.join(','));
    });
    return csvRows.join('\n');
  };

  const handleDownloadReport = async () => {
    if (!reduxOrg._id) {
      console.error('Organization ID is required for downloading report');
      return;
    }
    try {
      // include viewer tz so server can compute day boundaries in user's timezone if desired
      const tzQuery = `tz=${encodeURIComponent(userTz)}`;
      const response = await API.getAllDonationsForNp(reduxOrg._id, tzQuery);
      const allDonations = response.data;
      const csvContent = convertToCSV(allDonations);
      downloadCSV(csvContent, 'donations_report.csv');
    } catch (error) {
      console.error('Error downloading report:', error);
    }
  };

  // Mobile-specific callback functions
  const handleMobileManageDonations = () => {
    setDesktopOnlyModal(true);
  };

  const handleMobileManageStore = () => {
    // Scroll to Categories section
    const categoriesSection = document.querySelector('.md-categories');
    if (categoriesSection) {
      categoriesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleMobileManageWishlist = () => {
    // Scroll to Categories section
    const categoriesSection = document.querySelector('.md-categories');
    if (categoriesSection) {
      categoriesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleSort = (field: 'date' | 'amount' | 'name') => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedDonations = [...donations].sort((a, b) => {
    const aValue = a[sortField];
    const bValue = b[sortField];

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortDirection === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
    }

    return 0;
  });

  const totalAmount = donations.reduce((sum, donation) => sum + (donation.amount || 0), 0);

  // Formatting functions (same as ActionSection)
  const fmt$ = (n: number) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);
  const fmtN = (n: number) => new Intl.NumberFormat('en-US').format(n);

  const getSharingProps = (id: string) => {
    if (id === 'profile') {
      return {
        componentHeaderText: 'Share your profile page',
        url: 'https://neddie.co/nonprofit/' + reduxOrg._id,
        postDescription: 'Check out the ' + reduxOrg.name + ' profile page on Neddie',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    } else if (id === 'wishlist') {
      return {
        componentHeaderText: 'Share your wishlist',
        url: reduxOrg?.actionItems?.wishlist,
        postDescription: 'Check out the ' + reduxOrg.name + ' Wishlist ',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    } else if (id === 'store') {
      return {
        componentHeaderText: 'Share your marketplace',
        url: reduxOrg?.actionItems?.marketplace,
        postDescription: 'Check out the ' + reduxOrg.name + ' Marketplace ',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    } else if (id === 'fundraiser') {
      return {
        componentHeaderText: 'Share this Fundraiser',
        url: 'https://neddie.co/donation/' + reduxOrg._id + '/' + selectedCampaign.campaignId,
        postDescription: 'Check out the ' + selectedCampaign?.name + ' Fundraiser',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    }
    return null;
  };

  // Touch/Swipe handlers for banner scrolling
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && currentBannerIndex < 2) {
      setCurrentBannerIndex(currentBannerIndex + 1);
    }

    if (isRightSwipe && currentBannerIndex > 0) {
      setCurrentBannerIndex(currentBannerIndex - 1);
    }
  };

  const handleScroll = () => {
    if (!bannerScrollRef.current || isScrolling) return;

    const scrollLeft = bannerScrollRef.current.scrollLeft;
    const bannerWidth = 320 + 16; // banner width + gap
    const newIndex = Math.round(scrollLeft / bannerWidth);

    if (newIndex !== currentBannerIndex && newIndex >= 0 && newIndex <= 2) {
      setIsScrolling(true);
      setCurrentBannerIndex(newIndex);
      setTimeout(() => setIsScrolling(false), 100);
    }
  };

  // Auto-scroll effect
  React.useEffect(() => {
    if (bannerScrollRef.current) {
      const bannerWidth = 320 + 16; // banner width + gap
      bannerScrollRef.current.scrollTo({
        left: currentBannerIndex * bannerWidth,
        behavior: 'smooth'
      });
    }
  }, [currentBannerIndex]);
  return (
    <>
      <div className="mobile-dashboard">
        {/* Top App Bar */}
        <MobileTopBar
          onMobileManageDonations={handleMobileManageDonations}
          onMobileManageStore={handleMobileManageStore}
          onMobileManageWishlist={handleMobileManageWishlist}
        />

        {/* Gray notice strip */}
        <div className="md-desktop-strip">
          For the best experience, use the desktop dashboard.
        </div>

        {/* Welcome + breadcrumb row */}
        <div className="md-page">
          <h2 className="md-welcome">Welcome {reduxOrg?.name || 'Organization'}!</h2>

          <div className="md-breadcrumb">
            <img src="/mobile-icon/dashobard.png" alt="donations" />
            <span >Dashboard</span>
          </div>

          {/* Quick actions card (5 icons exactly like screenshot) */}
          <div className="md-card md-quick-actions">
            <div className="md-qa-item" onClick={() => history.push(`/nonprofit/${reduxOrg?._id}`)}>
              <div className="md-qa-ico">
                <img style={{ width: "50px" }} src="/mobile-icon/3.png" alt="donations" />
              </div>
              <small>My Profile</small>
            </div>
            <div className="md-qa-item" onClick={() => history.push('/manage-pay')}>
              <div className="md-qa-ico">
                <img style={{ width: "75%" }} src="/mobile-icon/8b0c2f25-5c87-4451-815c-7287be1b77ad.png" alt="donations" />
              </div>
              <small>Manage Donations</small>
            </div>
            <div className="md-qa-item" onClick={() => window.open("https://www.neddieblog.com/grant-central-search", "_blank")}>
              <div className="md-qa-ico">
                <img style={{ width: "80%" }} src="/mobile-icon/c268a748-44ba-4a0b-a114-67858a8e3293.png" alt="donations" />
              </div>
              <small>Search Grants</small>
            </div>
            <div className="md-qa-item" onClick={() => history.push('/settings')}>
              <div className="md-qa-ico">
                <img style={{ width: "80%" }} src="/mobile-icon/987078ac-22fd-4f0d-822b-08953889c680.png" alt="donations" />
              </div>
              <small>Settings</small>
            </div>
            <div className="md-qa-item" onClick={() => history.push('/help')}>
              <div className="md-qa-ico">
                <img style={{ width: "80%" }} src="/mobile-icon/c903f865-93a4-459c-a62c-42624728cb25.png" alt="donations" />
              </div>
              <small>Help</small>
            </div>
          </div>

          {/* Enhanced overview card with real data */}
          <div className="md-card md-overview">
            <div className="md-ov-header">
              <span className="md-ov-title">Overview</span>
              {loadingOverview && <span className="md-loading-text">Loading...</span>}
            </div>

            <div className="md-ov-row">
              <div className="md-ov-left">
                <span className="md-ov-ico">
                  <img style={{ width: "45px" }} src="/icons/15.png" alt="YTD donations" />
                </span>
                <span className="md-ov-title">YTD Donations</span>
              </div>
              <div className="md-ov-amt">{fmt$(overviewData.yearDonations)}</div>
            </div>
            <div className="md-ov-row">
              <div className="md-ov-left">
                <span className="md-ov-ico">
                  <img style={{ width: "45px" }} src="/icons/16.png" alt="Supporters" />
                </span>
                <span className="md-ov-title">Supporters</span>
              </div>
              <div className="md-ov-amt">{fmtN(overviewData.supporters)}</div>
            </div>
            <div className="md-ov-row">
              <div className="md-ov-left">
                <span className="md-ov-ico">
                  <img style={{ width: "45px" }} src="/icons/17.png" alt="All donations" />
                </span>
                <span className="md-ov-title">All Donations</span>
              </div>
              <div className="md-ov-amt">{fmt$(overviewData.allDonations)}</div>
            </div>
          </div>

          {/* Enhanced donations table-style card */}
          <div className="md-card md-latest">
            <div className="md-table-header">
              <h3>Latest Donations</h3>
              <button
                className="md-download-btn"
                onClick={handleDownloadReport}
                title="Download CSV Report"
              >
                <FaDownload style={{ color: "gray" }} />
              </button>
            </div>

            {loadingDonations ? (
              <div className="md-loading">Loading donations...</div>
            ) : (
              <div className="md-table">
                <div className="md-th">
                  <span
                    className={`md-sortable ${sortField === 'date' ? 'sorted' : ''}`}
                    onClick={() => handleSort('date')}
                  >
                    Date
                    {sortField === 'date' && (
                      <span className="sort-indicator">
                        {sortDirection === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span
                    className={`md-sortable ${sortField === 'amount' ? 'sorted' : ''}`}
                    onClick={() => handleSort('amount')}
                  >
                    Amount
                    {sortField === 'amount' && (
                      <span className="sort-indicator">
                        {sortDirection === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span>Email</span>
                  {/* <span>Type</span> */}

                </div>

                {sortedDonations.length === 0 ? (
                  <div className="md-no-data">No donations found</div>
                ) : (
                  sortedDonations.slice(0, 4).map((donation, index) => (
                    <div key={donation._id || donation.id || index} className="md-tr">
                      <span className="md-date">
                        <i className={`md-dot ${index > 1 ? 'old' : ''}`} />
                        <span className="md-date-text">
                          {formatDate(donation.createdAt || donation.date || new Date().toISOString())}
                        </span>
                      </span>
                      <span className="md-money">{formatCurrency(donation.amount || 0)}</span>
                      <span className="md-email">
                        {donation.email === 'Anonymous' || !donation.email ? (
                          <>
                            <i className="md-dot hollow" /> Anonymous
                          </>
                        ) : (
                          donation.email
                        )}
                      </span>
                      {/* <span className={`md-pill ${donation.type === 'Recurring' ? 'md-rec' : 'md-one'}`}>
                        {donation.type || 'One time'}
                      </span> */}
                      {/* <span className={`md-status ${getStatusColor(donation.status || 'Completed')}`}>
                        {donation.status || 'Completed'}
                      </span>
                      <span className="md-email-action">
                        {donation.email && donation.email !== 'Anonymous' && (
                          <img
                            onClick={() => window.location.href = `mailto:${donation.email}`}
                            className="email-btn"
                            title="Send Email"
                            src="/icons/email.png"
                            alt="Email"
                          />
                        )}
                      </span> */}
                    </div>
                  ))
                )}
              </div>
            )}

            <div className="md-table-footer">
              <div className="md-summary">
                <span className="summary-text">
                  Showing {Math.min(sortedDonations.length, 4)} of {sortedDonations.length} donations
                </span>
                <span className="total-amount">Total: {formatCurrency(totalAmount)}</span>
              </div>
              <div className="md-see-all">
                <button type="button" onClick={() => setGoToDaskboardPopup(true)}>
                  To see all donations go to your desktop.
                </button>
              </div>
            </div>
          </div>

          {/* Scrollable Banner Section */}
          <div className="md-banner-container">
            <div
              className="md-banner-scroll"
              ref={bannerScrollRef}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onScroll={handleScroll}
            >
              {/* Grant Central Banner */}
              <div className="md-grant">
                <div className="md-grant-text">
                  <div>
                    <h3>NEDDIE Grant Central</h3>
                    <a
                      href="https://www.neddieblog.com/grant-central-search"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Find grants now →
                    </a>
                  </div>
                  <label onClick={() => window.open("https://www.neddieblog.com/grant-central-faqs", "_blank")} className="md-link block" htmlFor="">Haven't sign up? click here</label>
                </div>
                <img
                  className="md-grant-img"
                  src="/mobile-icon/width_800.webp"
                  alt="Grant Central"
                />
              </div>

              {/* Additional Banner 1 - NEDDIE Integration */}
              <div className="md-grant md-grant-integration">
                <div className="md-integration-text">
                  <h3>Add NEDDIE Payments to Your Website</h3>
                  <p>Streamline your donations <br /> all in one place.</p>
                  <Link to={'/neddie-integration'} className="md-learn-more">Learn more</Link>
                </div>
                {/* <img
                style={{width:"75px",marginLeft:"33px"}}
                  className=""
                  src="/mobile-icon/screenshot_2.png"
                  alt="NEDDIE Integration"
                /> */}
              </div>


            </div>
          </div>

          {/* Categories Section */}
          <div className="md-card md-categories">
            <div className="md-categories-header">
              <h3>Categories</h3>
              <a
                href="#"
                className="md-see-all-link"
                onClick={(e) => {
                  e.preventDefault();
                  history.push('/nonprofit-categories');
                }}
              >
                See all
              </a>
            </div>

            <div className="md-categories-scroll">
              <div className="md-category-item" onClick={() => setManageStoreModal(true)}>
                <div className="md-category-icon">
                  <img src="/mobile-icon/2.png" alt="Manage store" />
                </div>
                <small>Manage Store</small>
              </div>

              <div className="md-category-item" onClick={() => setManageWishlistModal(true)}>
                <div className="md-category-icon">
                  <img src="/mobile-icon/7.png" alt="Manage wishlist" />
                </div>
                <small>Manage Wishlist</small>
              </div>

              <div className="md-category-item" onClick={() => history.push("/neddie-integration")}>
                <div className="md-category-icon">
                  <img src="/mobile-icon/Screenshot_4.png" alt="NEDDIE payments" />
                </div>
                <small>Neddie Integeration</small>
              </div>

              <div className="md-category-item" onClick={() => history.push("/connect-payments")}>
                <div className="md-category-icon">
                  <img src="/mobile-icon/5.png" alt="Connect payments" />
                </div>
                <small>Connect Payments</small>
              </div>

              <div className="md-category-item" onClick={() => setSocialShareHub(true)}>
                <div className="md-category-icon">
                  <img src="/mobile-icon/Screenshot_3.png" alt="Social share hub" />
                </div>
                <small>Social Share Hub</small>
              </div>
              <div className="md-category-item" onClick={() => window.open("https://www.neddieblog.com/neddie-events", "_blank")}>
                <div className="md-category-icon">
                  <img src="/mobile-icon/6.png" alt="NEDDIE Event" />
                </div>
                <small>NEDDIE Events</small>
              </div>
              <div className="md-category-item" onClick={() => window.open('https://www.neddieblog.com/')}>
                <div className="md-category-icon">
                  <img src="/mobile-icon/4.png" alt="Social share hub" />
                </div>
                <small>Resources</small>
              </div>
            </div>
          </div>

          {/* Footer */}
          {/* <div className="md-footer">© {new Date().getFullYear()} Neddie, all rights reserved</div> */}
        </div>
      </div>
      {/* Fixed Footer Navigation */}
      <div className="nonprofit-categories-bottom-nav">
        <div className="nonprofit-categories-bottom-nav-content">
          {/* Home */}
          <div
            className="nonprofit-categories-nav-item nonprofit-categories-nav-item-active"
            onClick={() => history.push('/dashboard')}
          >
            <FaHome style={{ fontSize: "22px", color: '#5271ff' }} />
            <span className="nonprofit-categories-nav-label nonprofit-categories-nav-label-active">Home</span>
          </div>

          {/* Give hub */}
          <div
            className="nonprofit-categories-nav-item"
            onClick={() => history.push('/manage-pay')}
          >
            <FaTh style={{ fontSize: "22px", color: '#b6b6b6' }} />
            <span className="nonprofit-categories-nav-label">Manage Donations</span>
          </div>

          {/* Profile */}
          <div
            className="nonprofit-categories-nav-item"
            onClick={() => history.push(`/nonprofit/${reduxOrg?._id}`)}
          >
            <FaUser style={{ fontSize: "22px", color: '#b6b6b6' }} />
            <span className="nonprofit-categories-nav-label">Profile</span>
          </div>

          {/* Settings */}
          <div
            className="nonprofit-categories-nav-item"
            onClick={() => history.push('/settings')}
          >
            <IoMdSettings style={{ fontSize: "22px", color: '#b6b6b6' }} />
            <span className="nonprofit-categories-nav-label">Settings</span>
          </div>
        </div>
      </div>


      {/* Modals (unchanged) */}
      <ManageWishlistPopup wishList={wishList} setWishList={setWishList} />
      <GoToDaskboardPopup
        goToDaskboardPopup={goToDaskboardPopup}
        setGoToDaskboardPopup={setGoToDaskboardPopup}
      />
      <ManageMarketPlacePopup
        marketPlace={marketPlace}
        setMarketPlace={setMarketPlace}
      />
      <QuickSharePopup shareLink={shareLink} setShareLink={setShareLink} />
      <WhatsNewPopup whatsNew={whatsNew} setWhatsNew={setWhatsNew} />
      <DashboardSetting
        dashboardSetting={dashboardSetting}
        setDashboardSetting={setDashboardSetting}
      />

      <Modal
        show={apiIntegration}
        onHide={() => setApiIntegration(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>API Integration Tools</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {reduxOrg?._id && (
            <NonprofitApiIntegration
              nonprofitId={reduxOrg._id}
              nonprofitName={reduxOrg.name}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* Social Share Hub Modal */}
      <Modal
        show={socialShareHub}
        onHide={() => setSocialShareHub(false)}
        size="lg"
        className="social-share-modal"
        dialogClassName="modal-bottom"
      >
        <Modal.Header closeButton>
          <Modal.Title>Social Share Hub</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="social-share-grid">
            <div className="social-share-item" onClick={() => { setShowSharingModal(true); setSelectedSharingItem('profile'); }}>
              <div className="social-share-icon share-profile">
                <img style={{ width: "44px" }} src={userIcon} alt="profile" />
              </div>
              <small>Share Profile</small>
            </div>

            <div className="social-share-item" onClick={() => { setShowSharingModal(true); setSelectedSharingItem('wishlist'); }}>
              <div className="social-share-icon share-wishlist">
                <img style={{ width: "44px" }} src="/mobile-icon/7.png" alt="icon" />
              </div>
              <small>Share Wishlist</small>
            </div>

            <div className="social-share-item" onClick={() => { setShowSharingModal(true); setSelectedSharingItem('store'); }}>
              <div className="social-share-icon share-store">
                <img style={{ width: "44px" }} src="/mobile-icon/2.png" alt="icon" />
              </div>
              <small>Share Store</small>
            </div>

            {/* Dynamic fundraiser items from campaigns */}
            {campaigns.length > 0 ? (
              <>
                {campaigns.slice(0, 3).map((campaign, index) => {
                  console.log('🏗️ Rendering campaign:', campaign);
                  return (
                    <div
                      key={campaign._id || campaign.id || index}
                      className="social-share-item"
                      onClick={() => {
                        setShowSharingModal(true);
                        setSelectedSharingItem('fundraiser');
                        setSelectedselectedCampaign(campaign)
                        // setSelectedSharingItem("Fundraiser")
                        // console.log('🚀 Campaign clicked:', campaign);
                        // console.log('🎯 Navigating to:', `/donation/${reduxOrg._id}/${campaign._id}/default`);
                        // history.push(`/donation/${reduxOrg._id}/default`);
                      }}
                    >
                      <div className="social-share-icon share-fundraiser">
                        <img style={{ width: "44px", height: '44px', objectFit: 'contain' }} src={flagIcon} alt="fundraiser" />
                      </div>
                      <small>{campaign.name || `Campaign ${index + 1}`}</small>
                    </div>
                  );
                })}
              </>
            ) : (
              /* Show static data when no campaigns */
             null
            )}
          </div>
        </Modal.Body>
      </Modal>


      {/* Manage Wishlist Modal */}
      <Modal
        show={manageWishlistModal}
        onHide={() => setManageWishlistModal(false)}
        size="lg"
        className="manage-wishlist-modal"
        dialogClassName="modal-bottom"
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Wishlist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="wishlist-content">
            <h4 className="wishlist-subtitle">What's a Wishlist for?</h4>
            <p className="wishlist-description">
              At NEDDIE, nonprofits can create and share a wishlist of needed items,
              whether from Amazon, Walmart, or other retailers. It's a simple way
              for donors to give tangible support by purchasing exactly what an
              organization needs. From supplies to equipment, every item helps
              move the mission forward.
            </p>

            {/* Current wishlist link display */}
            <div className="current-wishlist-link">
              <p className="wishlist-hint">
                {reduxOrg?.actionItems?.wishlist || 'http://www.amazon.com/mynonprofitwishlist'}
              </p>
            </div>

            <div className="wishlist-link-section">
              <label htmlFor="wishlist-input" className="wishlist-link-label">Wishlist Link</label>
              <input
                id="wishlist-input"
                type="text"
                name="wishlist"
                className="wishlist-link-input"
                placeholder="Paste your wishlist link here"
                onChange={handleWishlistChange}
                required
                value={wishlistInput.wishlist || ''}
              />
            </div>

            <div className="wishlist-modal-footer">
              <button
                className="wishlist-submit-btn"
                onClick={handleWishlistSubmit}
                disabled={wishlistSubmitting}
              >
                {wishlistSubmitting ? 'Submitting…' : 'Submit'}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Manage Store Modal */}
      <Modal
        show={manageStoreModal}
        onHide={() => setManageStoreModal(false)}
        size="lg"
        className="manage-store-modal"
        dialogClassName="modal-bottom"
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Store</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="store-content">
            <h4 className="store-subtitle">What's the store for?</h4>
            <p className="store-description">
              At NEDDIE, nonprofits can upload a link to their online store.
              Our store feature helps organizations promote their products and
              generate extra support through sales, making it easier for donors
              to shop with purpose.
            </p>

            {/* Current store link display */}
            <div className="current-store-link">
              <p className="store-hint">
                {reduxOrg?.actionItems?.marketplace}
              </p>
            </div>

            <div className="store-link-section">
              <label htmlFor="store-marketplace" className="store-link-label">Store Link</label>
              <input
                id="store-marketplace"
                type="text"
                name="marketplace"
                className="store-link-input"
                placeholder="Paste your store link here"
                onChange={handleStoreChange}
                required
                value={storeInput.marketplace || ''}
              />
            </div>

            <div className="store-modal-footer">
              <button
                className="store-submit-btn"
                onClick={handleStoreSubmit}
                disabled={storeSubmitting}
              >
                {storeSubmitting ? 'Submitting…' : 'Submit'}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Desktop Only Modal */}
      <Modal
        show={desktopOnlyModal}
        onHide={() => setDesktopOnlyModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Desktop Feature</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              To see this feature, visit the dashboard on desktop.
            </p>
          </div>
        </Modal.Body>
      </Modal>

      {/* Store Submit Result Modal */}
      <Modal
        show={showStoreSubmitModal}
        onHide={() => setShowStoreSubmitModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{storeSubmitError ? 'Error' : 'Success'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ fontSize: '16px', color: storeSubmitError ? 'red' : 'green' }}>
              {storeSubmitMessage}
            </p>
          </div>
        </Modal.Body>
      </Modal>

      {/* Wishlist Submit Result Modal */}
      <Modal
        show={showWishlistSubmitModal}
        onHide={() => setShowWishlistSubmitModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{wishlistSubmitError ? 'Error' : 'Success'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ fontSize: '16px', color: wishlistSubmitError ? 'red' : 'green' }}>
              {wishlistSubmitMessage}
            </p>
          </div>
        </Modal.Body>
      </Modal>

      {/* Advanced Sharing Modal */}
      <Modal
        show={showSharingModal}
        onHide={() => setShowSharingModal(false)}
        size="lg"
        className="manage-share-popups"
        dialogClassName="modal-bottom"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedSharingItem === 'profile'
              ? 'Share your profile page'
              : selectedSharingItem === 'wishlist'
                ? 'Share your wishlist'
                : selectedSharingItem === 'fundraiser'
                  ? 'Share your fundraiser'
                  : 'Share your marketplace'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="sharing-options-modal-body">
            <div className="sharing-grid">
              <div className="share-item">
                <FacebookShareButton
                  className="share-circle"
                  url={getSharingProps(selectedSharingItem!)?.url}
                  quote={getSharingProps(selectedSharingItem!)?.postDescription}
                  hashtag="NEDDIE"
                >
                  <FacebookIcon size={40} round />
                </FacebookShareButton>
                <small>Facebook</small>
              </div>

              <div className="share-item">
                <LinkedinShareButton
                  className="share-circle"
                  url={getSharingProps(selectedSharingItem!)?.url}
                  summary={getSharingProps(selectedSharingItem!)?.postDescription}
                >
                  <LinkedinIcon size={40} round />
                </LinkedinShareButton>
                <small>LinkedIn</small>
              </div>

              <div className="share-item">
                <TwitterShareButton
                  className="share-circle"
                  url={getSharingProps(selectedSharingItem!)?.url}
                  title={getSharingProps(selectedSharingItem!)?.postDescription}
                  hashtags={getSharingProps(selectedSharingItem!)?.twitterHashtags}
                >
                  <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#000000', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: '18px' , minWidth:'40px' }}>X</div>
                </TwitterShareButton>
                <small>X</small>
              </div>

              <div className="share-item">
                <EmailShareButton
                  className="share-circle"
                  url={getSharingProps(selectedSharingItem!)?.url}
                  subject={getSharingProps(selectedSharingItem!)?.postDescription}
                >
                  <EmailIcon size={40} round />
                </EmailShareButton>
                <small>Email</small>
              </div>
              <div className="share-item">
                <WhatsappShareButton className="share-circle" url={getSharingProps(selectedSharingItem!)?.url} title={getSharingProps(selectedSharingItem!)?.postDescription}>
                  <WhatsappIcon size={40} round />
                </WhatsappShareButton>
                <small>Whatsapp</small>
              </div>
            </div>
            <div className="share-link-row">
              <label>Page Link</label>
              <div className="share-link-input">
                <input
                  readOnly
                  value={getSharingProps(selectedSharingItem!)?.url || ''}
                  onFocus={(e) => e.currentTarget.select()}
                />
                <button
                  type="button"
                  className="copy-btn"
                  onClick={() => {
                    navigator.clipboard.writeText(getSharingProps(selectedSharingItem!)?.url || '');
                  }}
                >
                  Copy
                </button>
              </div>
            </div>

            <div className="close-button-container">
              <button className="btn btn-light" onClick={() => setShowSharingModal(false)}>Cancel</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MobileDashboard;
